import { createResource, type RouterContext } from 'react-resource-router';

import { default as IntegrationListAPI } from '../endpoints';

import { type IntegrationListResource } from './types';

export const integrationListResource = createResource<IntegrationListResource>({
	type: 'integrationListResource',
	getKey: ({ query }: RouterContext): string => {
		const group = query['group'];
		const keyword = query['keyword'];
		return `integrationListResource?group=${group}&keyword=${keyword}`;
	},
	getData: async (routerContext) =>
		await IntegrationListAPI.getIntegrationList(
			routerContext.query,
			routerContext.match.params.teamId,
		),
	maxAge: 5 * 60 * 1000, // 5 minutes
	isBrowserOnly: true,
});
